import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space, Spin } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IAddBeneficiaryStatusLookupListFormValues } from '../../../../../interfaces/lookup/beneficiaryStatus';
import { IAddBeneficiaryStatus } from '../../../../../interfaces/lookup/beneficiaryStatus/data';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { FetchResult } from '../../../../../shared/components/fetchResult/FetchResult';
import { ROW_GUTTER } from '../../../../../shared/Constants';
import { isError } from '../../../../../shared/helpers';
import { AppDispatch, RootState } from '../../../../../store';
import { addBeneficiaryStatus } from '../../../../../store/lookupSlice/LookupActions';

export const BeneficiaryStatusLookupListAdd = (props: any) => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const lookupSlice = useSelector((state: RootState) => state.lookupSlice);

    const onFinish = (values: IAddBeneficiaryStatusLookupListFormValues) => {
        const body: IAddBeneficiaryStatus = {
            ...(values as any),
        };

        dispatch(addBeneficiaryStatus(body));
    };

    useEffect(() => {
        if (lookupSlice.detailsPage.beneficiaryStatus.createStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/beneficiary-status', { replace: true });
        }
    }, [lookupSlice.detailsPage.beneficiaryStatus.createStatus]);

    return (
        <Form
            form={form}
            name=""
            onFinish={onFinish}
            layout="vertical"
            onValuesChange={(changedValue: any, values) => {
                form.setFieldsValue(values);
            }}
        >
            <ContentHeader
                title="Manage beneficiary status lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Beneficiary status',
                        path: '/admin/lookup-lists/beneficiary-status',
                    },
                    {
                        breadcrumbName: 'Create',
                        path: `/admin/lookup-lists/beneficiary-status/add`,
                    },
                ]}
            >
                {!isError(lookupSlice.detailsPage.beneficiaryStatus.fetchStatus) && (
                    <Form.Item>
                        <Space>
                            <Button
                                icon={<CloseOutlined />}
                                onClick={() => navigate(-1)}
                                disabled={
                                    lookupSlice.detailsPage.beneficiaryStatus.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.beneficiaryStatus.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Close
                            </Button>
                            <Button
                                htmlType="submit"
                                type="primary"
                                icon={<SaveOutlined />}
                                loading={
                                    lookupSlice.detailsPage.beneficiaryStatus.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.beneficiaryStatus.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Save and close
                            </Button>
                        </Space>
                    </Form.Item>
                )}
            </ContentHeader>

            <div className="page-content">
                <Spin spinning={lookupSlice.detailsPage.beneficiaryStatus.fetchStatus === StatePieceStatus.IsFetching}>
                    {isError(lookupSlice.detailsPage.beneficiaryStatus.fetchStatus) ? (
                        <FetchResult status={lookupSlice.detailsPage.beneficiaryStatus.fetchStatus} about={'Beneficiary status'} />
                    ) : (
                        <>
                            <Row>
                                <Col span={24}>
                                    <Space>
                                        <label className="group-label">Beneficiary status option Information</label>
                                    </Space>
                                </Col>
                            </Row>
                            <Row gutter={ROW_GUTTER}>
                                <Col span={8}>
                                    <label className="property required">Code</label>
                                    <Form.Item name="code" rules={[{ required: true, message: "'Code' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <label className="property required">Description</label>
                                    <Form.Item name="description" rules={[{ required: true, message: "'Description' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>&nbsp;</Col>
                            </Row>
                        </>
                    )}
                </Spin>
            </div>
        </Form>
    );
};
